const path = require('path')

const IMG_DIR = path.resolve(__dirname, 'static/img')

module.exports = {
  creatorName: 'UFV',
  projectName: 'MCTIC-InovaData BR',
  logo: `${IMG_DIR}/logo.png`,
  imgDir: `${IMG_DIR}`,
  adminlte: {
    skin: 'skin-blue'
  }
}



// WEBPACK FOOTER //
// ./src/config.js